import { JOB_REJECTION_OPTIONS, JOB_SUBMIT_OPTIONS } from 'constants/job';
import moment from 'moment';

export const DECISION_OPTIONS = [
  { value: JOB_SUBMIT_OPTIONS.APPROVE, label: JOB_SUBMIT_OPTIONS.APPROVE },
  { value: JOB_SUBMIT_OPTIONS.REJECT, label: JOB_SUBMIT_OPTIONS.REJECT },
];

export const INITIAL_VALUES = {
  decision: undefined,
  opening: undefined,
  office: undefined,
  date: moment().add({ day: 7 }),
  rejection: JOB_REJECTION_OPTIONS.OTHER,
  comment: '',
};
